import React from 'react';
import VideoContainer from '../platformui/VideoContainer';

const VideoContainerBlock =
  (props) => <VideoContainer
    DisableVideoBlockText={true}
    {...props} />;

export default VideoContainerBlock;
